import { Box } from "@mui/material";
import {
  AdditionalServicesCard,
  Aml,
  ApplePayBlock,
  CryptoSwapWidget,
  ForeignCardBlock,
  ServicesPayment,
  SwiftBlock,
} from "../../components/pages/home";
import { useTheme } from "@mui/material/styles";
import { useTelegram, useDesktopLayout } from "../../hooks";
import { useFeatureFlags } from "../../contexts/FeatureFlagsContext";
import { v } from "../../utils/runtime";

export function ExchangePage() {
  const theme = useTheme();
  const { tg } = useTelegram();
  const { isFeatureEnabled } = useFeatureFlags();
  const isDesktop = useDesktopLayout();
  const isMobile =
    tg.platform !== "tdesktop" &&
    tg.platform !== "weba" &&
    tg.platform !== "macos";
  return (
    <Box
      sx={{
        display: "grid",
        gap: "25px",
        marginTop: isDesktop ? "0px" : isMobile ? "100px" : "200px",
        marginBottom: "100px",
      }}
    >
      {!isDesktop && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            width: "100%",
            height: "100%",
            backgroundImage:
              theme.palette.mode === "dark"
                ? `url('${v("/dark-theme-gradient.jpg")}')`
                : `url('${v("/light-theme-gradient.jpg")}')`,
            backgroundPosition: "top",
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% auto",
            maxHeight: "280px",
            objectFit: "contain",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            component="img"
            src={theme.palette.mode === "dark" ? v("/logo.svg") : v("/logo-l.svg")}
            alt="Zero Logo"
            sx={{
              paddingBottom: isMobile ? "0px" : "40px",
              width: isMobile ? "120px" : "145px",
              height: "auto",
            }}
          />
        </Box>
      )}
      {/* Кросс-чейн обмен крипта↔крипта через SwapKit — самый верхний блок.
          Скрываем целиком, если админ выключил фичу `exchange` в /settings.
          В таком случае вкладка визуально превращается в «Сервисы». */}
      {isFeatureEnabled("exchange") && <CryptoSwapWidget />}

      {/* Услуги — в один столбец. Каждый блок скрывается, если админ
          выключил соответствующую фичу в /settings. */}
      <Box
        sx={{ display: "grid", gridTemplateColumns: "1fr", gap: "16px" }}
      >
        {isFeatureEnabled("services_payment") && <ServicesPayment />}
        {isFeatureEnabled("aml") && <Aml />}
        {isFeatureEnabled("swift") && <SwiftBlock />}
        {isFeatureEnabled("foreign_card") && <ForeignCardBlock />}
      </Box>

      <ApplePayBlock />
      <AdditionalServicesCard />
    </Box>
  );
}
